import { createContext, Dispatch, ReactElement, useReducer, useRef, useCallback } from 'react'
import { useDeepMemo } from '@global/hooks/useDeepMemo'
import { reducer, initialState } from './reducer'
import { State, Action } from './types'

interface ContextValue {
  state: State
  dispatch: Dispatch<Action>
  gridRef: React.RefObject<unknown> | null
  setGridRef: (ref: unknown) => void
}

export const ReadGridToolbarContext = createContext<ContextValue>({
  state: initialState,
  dispatch: () => {
    // do nothing
  },
  gridRef: null,
  setGridRef: _ref => {
    // do nothing
  },
})

interface Props {
  children: ReactElement | ReactElement[]
}

export const ReadGridToolbarProvider = ({ children }: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const gridRef = useRef<unknown>(null)

  const setGridRef = useCallback((ref: unknown) => {
    gridRef.current = ref
  }, [])

  const value = useDeepMemo(
    () => ({ state, dispatch, setGridRef, gridRef }),
    [state, dispatch, gridRef],
  )

  return <ReadGridToolbarContext.Provider value={value}>{children}</ReadGridToolbarContext.Provider>
}
